<div class="dashboard">
  <ngrx-busy>
    @if (customer$ | async; as customer) {
      <a [routerLink]="['..', customer.id]"
        class="customer">
        <app-customer-card [customer]="customer"></app-customer-card>
      </a>
      <button mat-button
        class="mobile-pets-toggle"
        aria-controls="customer-pets"
        [attr.aria-expanded]="petsExpanded"
        (click)="petsExpanded = !petsExpanded">
        @if (selectedPetName$ | async; as petName) {
          <span class="selected-pet-name" [title]="petName">{{petName}}</span>
        }
        <span class="pets-menu-label">
          Pets
          <mat-icon>{{petsExpanded ? 'expand_less' : 'expand_more'}}</mat-icon>
        </span>
      </button>
      <div class="pets" id="customer-pets" [class.expanded]="petsExpanded">
        @for (ownerGr of pets$ | async | keyvalue; track ownerGr) {
          <div>
            <span class="pet-owner">
              {{ownerGr.key.full_name}}
            </span>
            @for (pet of ownerGr.value; track pet) {
              <app-pet-card [pet]="pet"
                [accepted]="pet.accepted"
                matRipple
                class="pet"
                [routerLink]="['..', customer.id, 'pets', pet.id]"
              [routerLinkActive]="['active']"></app-pet-card>
              <div class="shares">
                @for (share of pet.shares; track share) {
                  <a
                    class="share"
                    [routerLink]="!!share.full_name ? ['..', share.id] : undefined">
                    <img [src]="(share.avatar || '/assets/images/profile.jpg') + '?size=small&scale=2'"
                      class="avatar"
                      onerror="this.src='/assets/images/profile.jpg';"/>
                    <div class="profile">
                      <span class="name">{{share.full_name || share.email}}</span>
                      <span [ngClass]="share.accepted ? 'level' : 'level invited'">{{share.accepted ? 'Shared' : 'Invited'}} as {{share.level | humanize:'share_levels'}}</span>
                    </div>
                  </a>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </ngrx-busy>
</div>

<div class="dashboard-outlet">
  <router-outlet #outlet></router-outlet>
</div>
